import { render, staticRenderFns } from "./imagemagnify.vue?vue&type=template&id=efacd7e8&scoped=true&"
import script from "./imagemagnify.vue?vue&type=script&lang=js&"
export * from "./imagemagnify.vue?vue&type=script&lang=js&"
import style0 from "./imagemagnify.vue?vue&type=style&index=0&id=efacd7e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efacd7e8",
  null
  
)

export default component.exports